// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detailGANSAL_container__YkXPm {
  animation: detailGANSAL_init__1JLie 0.5s;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-bottom: 30px;
}

.detailGANSAL_container__YkXPm .detailGANSAL_noResults__-\\+R9z {
  font-size: 32px;
  font-weight: 300;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detailGANSAL_container__YkXPm .detailGANSAL_header__v2keZ {
  animation: detailGANSAL_init__1JLie 1.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detailGANSAL_container__YkXPm .detailGANSAL_header__v2keZ .detailGANSAL_arrow__v5Mxl {
  transition: 0.3s;
  border-radius: 100%;
}

.detailGANSAL_container__YkXPm .detailGANSAL_header__v2keZ .detailGANSAL_arrow__v5Mxl:hover {
  transition: 0.3s;
  scale: 1.1;
  filter: brightness(1.2);
  background-color: rgba(128, 128, 128, 0.15);
  cursor: pointer;
}

.detailGANSAL_container__YkXPm .detailGANSAL_header__v2keZ .detailGANSAL_titleContainer__0AOMh {
  display: flex;
  justify-content: center;
  align-items: center;
}

.detailGANSAL_container__YkXPm .detailGANSAL_header__v2keZ .detailGANSAL_titleContainer__0AOMh h4 {
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.detailGANSAL_container__YkXPm .detailGANSAL_header__v2keZ .detailGANSAL_button__AdsUj {
  display: flex;
  justify-content: center;
  align-items: center;
}

.detailGANSAL_container__YkXPm .detailGANSAL_data__BhIrU .detailGANSAL_tableContainer__yuqBz {
  border-radius: 5px;
  max-height: 70vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

@keyframes detailGANSAL_init__1JLie {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/CuponesGanadores/detail/detailGANSAL.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wCAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n\n.container .noResults {\n  font-size: 32px;\n  font-weight: 300;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header {\n  animation: init 1.3s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .arrow {\n  transition: 0.3s;\n  border-radius: 100%;\n}\n\n.container .header .arrow:hover {\n  transition: 0.3s;\n  scale: 1.1;\n  filter: brightness(1.2);\n  background-color: rgba(128, 128, 128, 0.15);\n  cursor: pointer;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .header .button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .data .tableContainer {\n  border-radius: 5px;\n  max-height: 70vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n@keyframes init {\n  0% {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `detailGANSAL_container__YkXPm`,
	"init": `detailGANSAL_init__1JLie`,
	"noResults": `detailGANSAL_noResults__-+R9z`,
	"header": `detailGANSAL_header__v2keZ`,
	"arrow": `detailGANSAL_arrow__v5Mxl`,
	"titleContainer": `detailGANSAL_titleContainer__0AOMh`,
	"button": `detailGANSAL_button__AdsUj`,
	"data": `detailGANSAL_data__BhIrU`,
	"tableContainer": `detailGANSAL_tableContainer__yuqBz`
};
export default ___CSS_LOADER_EXPORT___;
